function NoPage() {
    return (
        <div data-testid="no-page">
            <h1>404</h1>
        </div>
    );
}
export default NoPage;